import * as ambassadorWixMultilingualTranslationV1Content from './multilingual-translation-v1-content-translation-contents.http.js';
import * as ambassadorWixMultilingualTranslationV1ContentTypes from './multilingual-translation-v1-content-translation-contents.types.js';
import * as ambassadorWixMultilingualTranslationV1ContentUniversalTypes from './multilingual-translation-v1-content-translation-contents.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createContent(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixMultilingualTranslationV1ContentUniversalTypes.CreateContentRequest,
  ambassadorWixMultilingualTranslationV1ContentTypes.CreateContentRequest,
  ambassadorWixMultilingualTranslationV1ContentUniversalTypes.CreateContentResponse,
  ambassadorWixMultilingualTranslationV1ContentTypes.CreateContentResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixMultilingualTranslationV1Content.createContent(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/contents',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getContent(): __PublicMethodMetaInfo<
  'GET',
  { contentId: string },
  ambassadorWixMultilingualTranslationV1ContentUniversalTypes.GetContentRequest,
  ambassadorWixMultilingualTranslationV1ContentTypes.GetContentRequest,
  ambassadorWixMultilingualTranslationV1ContentUniversalTypes.GetContentResponse,
  ambassadorWixMultilingualTranslationV1ContentTypes.GetContentResponse
> {
  const payload = { contentId: ':contentId' } as any;

  const getRequestOptions =
    ambassadorWixMultilingualTranslationV1Content.getContent(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/contents/{contentId}',
    pathParams: { contentId: 'contentId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateContent(): __PublicMethodMetaInfo<
  'PATCH',
  { contentId: string },
  ambassadorWixMultilingualTranslationV1ContentUniversalTypes.UpdateContentRequest,
  ambassadorWixMultilingualTranslationV1ContentTypes.UpdateContentRequest,
  ambassadorWixMultilingualTranslationV1ContentUniversalTypes.UpdateContentResponse,
  ambassadorWixMultilingualTranslationV1ContentTypes.UpdateContentResponse
> {
  const payload = { content: { id: ':contentId' } } as any;

  const getRequestOptions =
    ambassadorWixMultilingualTranslationV1Content.updateContent(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/contents/{content.id}',
    pathParams: { contentId: 'contentId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateContentByKey(): __PublicMethodMetaInfo<
  'PATCH',
  {},
  ambassadorWixMultilingualTranslationV1ContentUniversalTypes.UpdateContentByKeyRequest,
  ambassadorWixMultilingualTranslationV1ContentTypes.UpdateContentByKeyRequest,
  ambassadorWixMultilingualTranslationV1ContentUniversalTypes.UpdateContentByKeyResponse,
  ambassadorWixMultilingualTranslationV1ContentTypes.UpdateContentByKeyResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixMultilingualTranslationV1Content.updateContentByKey(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/contents/by-key',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteContent(): __PublicMethodMetaInfo<
  'DELETE',
  { contentId: string },
  ambassadorWixMultilingualTranslationV1ContentUniversalTypes.DeleteContentRequest,
  ambassadorWixMultilingualTranslationV1ContentTypes.DeleteContentRequest,
  ambassadorWixMultilingualTranslationV1ContentUniversalTypes.DeleteContentResponse,
  ambassadorWixMultilingualTranslationV1ContentTypes.DeleteContentResponse
> {
  const payload = { contentId: ':contentId' } as any;

  const getRequestOptions =
    ambassadorWixMultilingualTranslationV1Content.deleteContent(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/contents/{contentId}',
    pathParams: { contentId: 'contentId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryContents(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixMultilingualTranslationV1ContentUniversalTypes.QueryContentsRequest,
  ambassadorWixMultilingualTranslationV1ContentTypes.QueryContentsRequest,
  ambassadorWixMultilingualTranslationV1ContentUniversalTypes.QueryContentsResponse,
  ambassadorWixMultilingualTranslationV1ContentTypes.QueryContentsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixMultilingualTranslationV1Content.queryContents(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/contents/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function searchContents(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixMultilingualTranslationV1ContentUniversalTypes.SearchContentsRequest,
  ambassadorWixMultilingualTranslationV1ContentTypes.SearchContentsRequest,
  ambassadorWixMultilingualTranslationV1ContentUniversalTypes.SearchContentsResponse,
  ambassadorWixMultilingualTranslationV1ContentTypes.SearchContentsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixMultilingualTranslationV1Content.searchContents(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/contents/search',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkCreateContent(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixMultilingualTranslationV1ContentUniversalTypes.BulkCreateContentRequest,
  ambassadorWixMultilingualTranslationV1ContentTypes.BulkCreateContentRequest,
  ambassadorWixMultilingualTranslationV1ContentUniversalTypes.BulkCreateContentResponse,
  ambassadorWixMultilingualTranslationV1ContentTypes.BulkCreateContentResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixMultilingualTranslationV1Content.bulkCreateContent(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/contents/create',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateContent(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixMultilingualTranslationV1ContentUniversalTypes.BulkUpdateContentRequest,
  ambassadorWixMultilingualTranslationV1ContentTypes.BulkUpdateContentRequest,
  ambassadorWixMultilingualTranslationV1ContentUniversalTypes.BulkUpdateContentResponse,
  ambassadorWixMultilingualTranslationV1ContentTypes.BulkUpdateContentResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixMultilingualTranslationV1Content.bulkUpdateContent(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/contents/update',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateContentByKey(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixMultilingualTranslationV1ContentUniversalTypes.BulkUpdateContentByKeyRequest,
  ambassadorWixMultilingualTranslationV1ContentTypes.BulkUpdateContentByKeyRequest,
  ambassadorWixMultilingualTranslationV1ContentUniversalTypes.BulkUpdateContentByKeyResponse,
  ambassadorWixMultilingualTranslationV1ContentTypes.BulkUpdateContentByKeyResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixMultilingualTranslationV1Content.bulkUpdateContentByKey(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/contents/update-by-key',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkDeleteContent(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixMultilingualTranslationV1ContentUniversalTypes.BulkDeleteContentRequest,
  ambassadorWixMultilingualTranslationV1ContentTypes.BulkDeleteContentRequest,
  ambassadorWixMultilingualTranslationV1ContentUniversalTypes.BulkDeleteContentResponse,
  ambassadorWixMultilingualTranslationV1ContentTypes.BulkDeleteContentResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixMultilingualTranslationV1Content.bulkDeleteContent(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/contents/delete',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getContentWordCount(): __PublicMethodMetaInfo<
  'GET',
  { sourceLanguage: string },
  ambassadorWixMultilingualTranslationV1ContentUniversalTypes.GetContentWordCountRequest,
  ambassadorWixMultilingualTranslationV1ContentTypes.GetContentWordCountRequest,
  ambassadorWixMultilingualTranslationV1ContentUniversalTypes.GetContentWordCountResponse,
  ambassadorWixMultilingualTranslationV1ContentTypes.GetContentWordCountResponse
> {
  const payload = { sourceLanguage: ':sourceLanguage' } as any;

  const getRequestOptions =
    ambassadorWixMultilingualTranslationV1Content.getContentWordCount(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/contents/word-count/{sourceLanguage}',
    pathParams: { sourceLanguage: 'sourceLanguage' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Content as ContentOriginal,
  ContentField as ContentFieldOriginal,
  ContentFieldValueOneOf as ContentFieldValueOneOfOriginal,
  RichContent as RichContentOriginal,
  Node as NodeOriginal,
  NodeDataOneOf as NodeDataOneOfOriginal,
  NodeType as NodeTypeOriginal,
  NodeTypeWithLiterals as NodeTypeWithLiteralsOriginal,
  NodeStyle as NodeStyleOriginal,
  ButtonData as ButtonDataOriginal,
  BackgroundType as BackgroundTypeOriginal,
  BackgroundTypeWithLiterals as BackgroundTypeWithLiteralsOriginal,
  Gradient as GradientOriginal,
  GradientType as GradientTypeOriginal,
  GradientTypeWithLiterals as GradientTypeWithLiteralsOriginal,
  Stop as StopOriginal,
  Border as BorderOriginal,
  Colors as ColorsOriginal,
  Background as BackgroundOriginal,
  PluginContainerData as PluginContainerDataOriginal,
  WidthType as WidthTypeOriginal,
  WidthTypeWithLiterals as WidthTypeWithLiteralsOriginal,
  PluginContainerDataWidth as PluginContainerDataWidthOriginal,
  PluginContainerDataWidthDataOneOf as PluginContainerDataWidthDataOneOfOriginal,
  PluginContainerDataAlignment as PluginContainerDataAlignmentOriginal,
  PluginContainerDataAlignmentWithLiterals as PluginContainerDataAlignmentWithLiteralsOriginal,
  Spoiler as SpoilerOriginal,
  Height as HeightOriginal,
  ButtonDataType as ButtonDataTypeOriginal,
  ButtonDataTypeWithLiterals as ButtonDataTypeWithLiteralsOriginal,
  Styles as StylesOriginal,
  Link as LinkOriginal,
  LinkDataOneOf as LinkDataOneOfOriginal,
  Target as TargetOriginal,
  TargetWithLiterals as TargetWithLiteralsOriginal,
  Rel as RelOriginal,
  CodeBlockData as CodeBlockDataOriginal,
  TextStyle as TextStyleOriginal,
  TextAlignment as TextAlignmentOriginal,
  TextAlignmentWithLiterals as TextAlignmentWithLiteralsOriginal,
  DividerData as DividerDataOriginal,
  LineStyle as LineStyleOriginal,
  LineStyleWithLiterals as LineStyleWithLiteralsOriginal,
  Width as WidthOriginal,
  WidthWithLiterals as WidthWithLiteralsOriginal,
  DividerDataAlignment as DividerDataAlignmentOriginal,
  DividerDataAlignmentWithLiterals as DividerDataAlignmentWithLiteralsOriginal,
  FileData as FileDataOriginal,
  ViewMode as ViewModeOriginal,
  ViewModeWithLiterals as ViewModeWithLiteralsOriginal,
  FileSource as FileSourceOriginal,
  FileSourceDataOneOf as FileSourceDataOneOfOriginal,
  PDFSettings as PDFSettingsOriginal,
  GalleryData as GalleryDataOriginal,
  Media as MediaOriginal,
  ItemImage as ItemImageOriginal,
  Video as VideoOriginal,
  Item as ItemOriginal,
  ItemDataOneOf as ItemDataOneOfOriginal,
  GalleryOptions as GalleryOptionsOriginal,
  LayoutType as LayoutTypeOriginal,
  LayoutTypeWithLiterals as LayoutTypeWithLiteralsOriginal,
  Orientation as OrientationOriginal,
  OrientationWithLiterals as OrientationWithLiteralsOriginal,
  Crop as CropOriginal,
  CropWithLiterals as CropWithLiteralsOriginal,
  ThumbnailsAlignment as ThumbnailsAlignmentOriginal,
  ThumbnailsAlignmentWithLiterals as ThumbnailsAlignmentWithLiteralsOriginal,
  GalleryOptionsLayout as GalleryOptionsLayoutOriginal,
  ItemStyle as ItemStyleOriginal,
  Thumbnails as ThumbnailsOriginal,
  GIFData as GIFDataOriginal,
  GIF as GIFOriginal,
  GIFType as GIFTypeOriginal,
  GIFTypeWithLiterals as GIFTypeWithLiteralsOriginal,
  HeadingData as HeadingDataOriginal,
  HTMLData as HTMLDataOriginal,
  HTMLDataDataOneOf as HTMLDataDataOneOfOriginal,
  Source as SourceOriginal,
  SourceWithLiterals as SourceWithLiteralsOriginal,
  ImageData as ImageDataOriginal,
  StylesBorder as StylesBorderOriginal,
  ImageDataStyles as ImageDataStylesOriginal,
  LinkPreviewData as LinkPreviewDataOriginal,
  StylesPosition as StylesPositionOriginal,
  StylesPositionWithLiterals as StylesPositionWithLiteralsOriginal,
  LinkPreviewDataStyles as LinkPreviewDataStylesOriginal,
  MapData as MapDataOriginal,
  MapSettings as MapSettingsOriginal,
  MapType as MapTypeOriginal,
  MapTypeWithLiterals as MapTypeWithLiteralsOriginal,
  ParagraphData as ParagraphDataOriginal,
  PollData as PollDataOriginal,
  ViewRole as ViewRoleOriginal,
  ViewRoleWithLiterals as ViewRoleWithLiteralsOriginal,
  VoteRole as VoteRoleOriginal,
  VoteRoleWithLiterals as VoteRoleWithLiteralsOriginal,
  Permissions as PermissionsOriginal,
  Option as OptionOriginal,
  Settings as SettingsOriginal,
  PollLayoutType as PollLayoutTypeOriginal,
  PollLayoutTypeWithLiterals as PollLayoutTypeWithLiteralsOriginal,
  PollLayoutDirection as PollLayoutDirectionOriginal,
  PollLayoutDirectionWithLiterals as PollLayoutDirectionWithLiteralsOriginal,
  PollLayout as PollLayoutOriginal,
  OptionLayout as OptionLayoutOriginal,
  PollDesignBackgroundType as PollDesignBackgroundTypeOriginal,
  PollDesignBackgroundTypeWithLiterals as PollDesignBackgroundTypeWithLiteralsOriginal,
  BackgroundGradient as BackgroundGradientOriginal,
  PollDesignBackground as PollDesignBackgroundOriginal,
  PollDesignBackgroundBackgroundOneOf as PollDesignBackgroundBackgroundOneOfOriginal,
  PollDesign as PollDesignOriginal,
  OptionDesign as OptionDesignOriginal,
  Poll as PollOriginal,
  PollDataLayout as PollDataLayoutOriginal,
  Design as DesignOriginal,
  TextData as TextDataOriginal,
  Decoration as DecorationOriginal,
  DecorationDataOneOf as DecorationDataOneOfOriginal,
  DecorationType as DecorationTypeOriginal,
  DecorationTypeWithLiterals as DecorationTypeWithLiteralsOriginal,
  AnchorData as AnchorDataOriginal,
  ColorData as ColorDataOriginal,
  LinkData as LinkDataOriginal,
  MentionData as MentionDataOriginal,
  FontSizeData as FontSizeDataOriginal,
  FontType as FontTypeOriginal,
  FontTypeWithLiterals as FontTypeWithLiteralsOriginal,
  SpoilerData as SpoilerDataOriginal,
  FontFamilyData as FontFamilyDataOriginal,
  AppEmbedData as AppEmbedDataOriginal,
  AppEmbedDataAppDataOneOf as AppEmbedDataAppDataOneOfOriginal,
  Position as PositionOriginal,
  PositionWithLiterals as PositionWithLiteralsOriginal,
  AspectRatio as AspectRatioOriginal,
  AspectRatioWithLiterals as AspectRatioWithLiteralsOriginal,
  Resizing as ResizingOriginal,
  ResizingWithLiterals as ResizingWithLiteralsOriginal,
  Placement as PlacementOriginal,
  PlacementWithLiterals as PlacementWithLiteralsOriginal,
  Type as TypeOriginal,
  TypeWithLiterals as TypeWithLiteralsOriginal,
  Alignment as AlignmentOriginal,
  AlignmentWithLiterals as AlignmentWithLiteralsOriginal,
  Layout as LayoutOriginal,
  LayoutWithLiterals as LayoutWithLiteralsOriginal,
  AppType as AppTypeOriginal,
  AppTypeWithLiterals as AppTypeWithLiteralsOriginal,
  BookingData as BookingDataOriginal,
  EventData as EventDataOriginal,
  ButtonStyles as ButtonStylesOriginal,
  ImageStyles as ImageStylesOriginal,
  RibbonStyles as RibbonStylesOriginal,
  CardStyles as CardStylesOriginal,
  PricingData as PricingDataOriginal,
  VideoData as VideoDataOriginal,
  PlaybackOptions as PlaybackOptionsOriginal,
  EmbedData as EmbedDataOriginal,
  Oembed as OembedOriginal,
  CollapsibleListData as CollapsibleListDataOriginal,
  InitialExpandedItems as InitialExpandedItemsOriginal,
  InitialExpandedItemsWithLiterals as InitialExpandedItemsWithLiteralsOriginal,
  Direction as DirectionOriginal,
  DirectionWithLiterals as DirectionWithLiteralsOriginal,
  TableData as TableDataOriginal,
  Dimensions as DimensionsOriginal,
  TableCellData as TableCellDataOriginal,
  VerticalAlignment as VerticalAlignmentOriginal,
  VerticalAlignmentWithLiterals as VerticalAlignmentWithLiteralsOriginal,
  CellStyle as CellStyleOriginal,
  BorderColors as BorderColorsOriginal,
  BorderWidths as BorderWidthsOriginal,
  NullValue as NullValueOriginal,
  NullValueWithLiterals as NullValueWithLiteralsOriginal,
  ListValue as ListValueOriginal,
  AudioData as AudioDataOriginal,
  OrderedListData as OrderedListDataOriginal,
  BulletedListData as BulletedListDataOriginal,
  BlockquoteData as BlockquoteDataOriginal,
  CaptionData as CaptionDataOriginal,
  LayoutData as LayoutDataOriginal,
  ImageScalingScaling as ImageScalingScalingOriginal,
  ImageScalingScalingWithLiterals as ImageScalingScalingWithLiteralsOriginal,
  ImagePosition as ImagePositionOriginal,
  ImagePositionWithLiterals as ImagePositionWithLiteralsOriginal,
  Origin as OriginOriginal,
  OriginWithLiterals as OriginWithLiteralsOriginal,
  LayoutDataBackgroundType as LayoutDataBackgroundTypeOriginal,
  LayoutDataBackgroundTypeWithLiterals as LayoutDataBackgroundTypeWithLiteralsOriginal,
  BackdropType as BackdropTypeOriginal,
  BackdropTypeWithLiterals as BackdropTypeWithLiteralsOriginal,
  LayoutDataBackgroundImage as LayoutDataBackgroundImageOriginal,
  VerticalAlignmentAlignment as VerticalAlignmentAlignmentOriginal,
  VerticalAlignmentAlignmentWithLiterals as VerticalAlignmentAlignmentWithLiteralsOriginal,
  ResponsivenessBehaviour as ResponsivenessBehaviourOriginal,
  ResponsivenessBehaviourWithLiterals as ResponsivenessBehaviourWithLiteralsOriginal,
  DesignTarget as DesignTargetOriginal,
  DesignTargetWithLiterals as DesignTargetWithLiteralsOriginal,
  Banner as BannerOriginal,
  LayoutDataBackground as LayoutDataBackgroundOriginal,
  Backdrop as BackdropOriginal,
  LayoutCellData as LayoutCellDataOriginal,
  ShapeData as ShapeDataOriginal,
  ShapeDataStyles as ShapeDataStylesOriginal,
  CardData as CardDataOriginal,
  Scaling as ScalingOriginal,
  ScalingWithLiterals as ScalingWithLiteralsOriginal,
  ImagePositionPosition as ImagePositionPositionOriginal,
  ImagePositionPositionWithLiterals as ImagePositionPositionWithLiteralsOriginal,
  CardDataBackgroundType as CardDataBackgroundTypeOriginal,
  CardDataBackgroundTypeWithLiterals as CardDataBackgroundTypeWithLiteralsOriginal,
  CardDataBackground as CardDataBackgroundOriginal,
  BackgroundImage as BackgroundImageOriginal,
  TocData as TocDataOriginal,
  ListStyle as ListStyleOriginal,
  ListStyleWithLiterals as ListStyleWithLiteralsOriginal,
  Indentation as IndentationOriginal,
  IndentationWithLiterals as IndentationWithLiteralsOriginal,
  Metadata as MetadataOriginal,
  DocumentStyle as DocumentStyleOriginal,
  TextNodeStyle as TextNodeStyleOriginal,
  Image as ImageOriginal,
  VideoV2 as VideoV2Original,
  VideoResolution as VideoResolutionOriginal,
  Document as DocumentOriginal,
  UpdaterIdentity as UpdaterIdentityOriginal,
  UpdaterIdentityWithLiterals as UpdaterIdentityWithLiteralsOriginal,
  PublishStatus as PublishStatusOriginal,
  PublishStatusWithLiterals as PublishStatusWithLiteralsOriginal,
  CreateContentRequest as CreateContentRequestOriginal,
  CreateContentResponse as CreateContentResponseOriginal,
  GetContentRequest as GetContentRequestOriginal,
  GetContentResponse as GetContentResponseOriginal,
  UpdateContentRequest as UpdateContentRequestOriginal,
  UpdateContentResponse as UpdateContentResponseOriginal,
  UpdateContentByKeyRequest as UpdateContentByKeyRequestOriginal,
  UpdateContentByKeyResponse as UpdateContentByKeyResponseOriginal,
  DeleteContentRequest as DeleteContentRequestOriginal,
  DeleteContentResponse as DeleteContentResponseOriginal,
  QueryContentsRequest as QueryContentsRequestOriginal,
  CursorQuery as CursorQueryOriginal,
  CursorQueryPagingMethodOneOf as CursorQueryPagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryContentsResponse as QueryContentsResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  QueryContentsLegacyRequest as QueryContentsLegacyRequestOriginal,
  QueryV2 as QueryV2Original,
  QueryV2PagingMethodOneOf as QueryV2PagingMethodOneOfOriginal,
  Paging as PagingOriginal,
  QueryContentsLegacyResponse as QueryContentsLegacyResponseOriginal,
  PagingMetadataV2 as PagingMetadataV2Original,
  SearchContentsRequest as SearchContentsRequestOriginal,
  CursorSearch as CursorSearchOriginal,
  CursorSearchPagingMethodOneOf as CursorSearchPagingMethodOneOfOriginal,
  Aggregation as AggregationOriginal,
  AggregationKindOneOf as AggregationKindOneOfOriginal,
  RangeBucket as RangeBucketOriginal,
  SortType as SortTypeOriginal,
  SortTypeWithLiterals as SortTypeWithLiteralsOriginal,
  SortDirection as SortDirectionOriginal,
  SortDirectionWithLiterals as SortDirectionWithLiteralsOriginal,
  MissingValues as MissingValuesOriginal,
  MissingValuesWithLiterals as MissingValuesWithLiteralsOriginal,
  IncludeMissingValuesOptions as IncludeMissingValuesOptionsOriginal,
  ScalarType as ScalarTypeOriginal,
  ScalarTypeWithLiterals as ScalarTypeWithLiteralsOriginal,
  ValueAggregation as ValueAggregationOriginal,
  ValueAggregationOptionsOneOf as ValueAggregationOptionsOneOfOriginal,
  NestedAggregationType as NestedAggregationTypeOriginal,
  NestedAggregationTypeWithLiterals as NestedAggregationTypeWithLiteralsOriginal,
  RangeAggregation as RangeAggregationOriginal,
  ScalarAggregation as ScalarAggregationOriginal,
  DateHistogramAggregation as DateHistogramAggregationOriginal,
  Interval as IntervalOriginal,
  IntervalWithLiterals as IntervalWithLiteralsOriginal,
  NestedAggregationItem as NestedAggregationItemOriginal,
  NestedAggregationItemKindOneOf as NestedAggregationItemKindOneOfOriginal,
  AggregationType as AggregationTypeOriginal,
  AggregationTypeWithLiterals as AggregationTypeWithLiteralsOriginal,
  NestedAggregation as NestedAggregationOriginal,
  GroupByAggregation as GroupByAggregationOriginal,
  GroupByAggregationKindOneOf as GroupByAggregationKindOneOfOriginal,
  SearchDetails as SearchDetailsOriginal,
  Mode as ModeOriginal,
  ModeWithLiterals as ModeWithLiteralsOriginal,
  SearchContentsResponse as SearchContentsResponseOriginal,
  AggregationData as AggregationDataOriginal,
  ValueAggregationResult as ValueAggregationResultOriginal,
  RangeAggregationResult as RangeAggregationResultOriginal,
  NestedAggregationResults as NestedAggregationResultsOriginal,
  NestedAggregationResultsResultOneOf as NestedAggregationResultsResultOneOfOriginal,
  ValueResults as ValueResultsOriginal,
  RangeResults as RangeResultsOriginal,
  AggregationResultsScalarResult as AggregationResultsScalarResultOriginal,
  NestedValueAggregationResult as NestedValueAggregationResultOriginal,
  ValueResult as ValueResultOriginal,
  RangeResult as RangeResultOriginal,
  ScalarResult as ScalarResultOriginal,
  NestedResultValue as NestedResultValueOriginal,
  NestedResultValueResultOneOf as NestedResultValueResultOneOfOriginal,
  Results as ResultsOriginal,
  DateHistogramResult as DateHistogramResultOriginal,
  GroupByValueResults as GroupByValueResultsOriginal,
  DateHistogramResults as DateHistogramResultsOriginal,
  NestedResults as NestedResultsOriginal,
  AggregationResults as AggregationResultsOriginal,
  AggregationResultsResultOneOf as AggregationResultsResultOneOfOriginal,
  BulkCreateContentRequest as BulkCreateContentRequestOriginal,
  BulkCreateContentResponse as BulkCreateContentResponseOriginal,
  ItemMetadata as ItemMetadataOriginal,
  ApplicationError as ApplicationErrorOriginal,
  BulkContentResult as BulkContentResultOriginal,
  BulkActionMetadata as BulkActionMetadataOriginal,
  BulkUpdateContentRequest as BulkUpdateContentRequestOriginal,
  BulkUpdateContentRequestMaskedContent as BulkUpdateContentRequestMaskedContentOriginal,
  BulkUpdateContentResponse as BulkUpdateContentResponseOriginal,
  BulkUpdateContentResponseBulkContentResult as BulkUpdateContentResponseBulkContentResultOriginal,
  BulkUpdateContentByKeyRequest as BulkUpdateContentByKeyRequestOriginal,
  MaskedContent as MaskedContentOriginal,
  BulkUpdateContentByKeyResponse as BulkUpdateContentByKeyResponseOriginal,
  BulkUpdateContentByKeyResponseBulkContentResult as BulkUpdateContentByKeyResponseBulkContentResultOriginal,
  PermissiveBulkUpdateContentRequest as PermissiveBulkUpdateContentRequestOriginal,
  PermissiveBulkUpdateContentRequestMaskedContent as PermissiveBulkUpdateContentRequestMaskedContentOriginal,
  PermissiveBulkUpdateContentResponse as PermissiveBulkUpdateContentResponseOriginal,
  PermissiveBulkUpdateContentResponseBulkContentResult as PermissiveBulkUpdateContentResponseBulkContentResultOriginal,
  BulkDeleteContentRequest as BulkDeleteContentRequestOriginal,
  BulkDeleteContentResponse as BulkDeleteContentResponseOriginal,
  BulkDeleteContentResponseBulkContentResult as BulkDeleteContentResponseBulkContentResultOriginal,
  MetaSiteSpecialEvent as MetaSiteSpecialEventOriginal,
  MetaSiteSpecialEventPayloadOneOf as MetaSiteSpecialEventPayloadOneOfOriginal,
  Asset as AssetOriginal,
  State as StateOriginal,
  StateWithLiterals as StateWithLiteralsOriginal,
  SiteCreated as SiteCreatedOriginal,
  SiteCreatedContext as SiteCreatedContextOriginal,
  SiteCreatedContextWithLiterals as SiteCreatedContextWithLiteralsOriginal,
  Namespace as NamespaceOriginal,
  NamespaceWithLiterals as NamespaceWithLiteralsOriginal,
  SiteTransferred as SiteTransferredOriginal,
  SiteDeleted as SiteDeletedOriginal,
  DeleteContext as DeleteContextOriginal,
  DeleteStatus as DeleteStatusOriginal,
  DeleteStatusWithLiterals as DeleteStatusWithLiteralsOriginal,
  SiteUndeleted as SiteUndeletedOriginal,
  SitePublished as SitePublishedOriginal,
  SiteUnpublished as SiteUnpublishedOriginal,
  SiteMarkedAsTemplate as SiteMarkedAsTemplateOriginal,
  SiteMarkedAsWixSite as SiteMarkedAsWixSiteOriginal,
  ServiceProvisioned as ServiceProvisionedOriginal,
  ServiceRemoved as ServiceRemovedOriginal,
  SiteRenamed as SiteRenamedOriginal,
  SiteHardDeleted as SiteHardDeletedOriginal,
  NamespaceChanged as NamespaceChangedOriginal,
  StudioAssigned as StudioAssignedOriginal,
  StudioUnassigned as StudioUnassignedOriginal,
  SiteUrlChanged as SiteUrlChangedOriginal,
  SitePurgedExternally as SitePurgedExternallyOriginal,
  OdeditorAssigned as OdeditorAssignedOriginal,
  OdeditorUnassigned as OdeditorUnassignedOriginal,
  PicassoAssigned as PicassoAssignedOriginal,
  PicassoUnassigned as PicassoUnassignedOriginal,
  WixelAssigned as WixelAssignedOriginal,
  WixelUnassigned as WixelUnassignedOriginal,
  StudioTwoAssigned as StudioTwoAssignedOriginal,
  StudioTwoUnassigned as StudioTwoUnassignedOriginal,
  UserDomainMediaEnabled as UserDomainMediaEnabledOriginal,
  UserDomainMediaDisabled as UserDomainMediaDisabledOriginal,
  EditorlessAssigned as EditorlessAssignedOriginal,
  EditorlessUnassigned as EditorlessUnassignedOriginal,
  Empty as EmptyOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  UpdateSchemaCacheRequest as UpdateSchemaCacheRequestOriginal,
  Schema as SchemaOriginal,
  SchemaKey as SchemaKeyOriginal,
  SchemaScope as SchemaScopeOriginal,
  SchemaScopeWithLiterals as SchemaScopeWithLiteralsOriginal,
  SchemaField as SchemaFieldOriginal,
  FieldType as FieldTypeOriginal,
  FieldTypeWithLiterals as FieldTypeWithLiteralsOriginal,
  PreviewFields as PreviewFieldsOriginal,
  UpdateSchemaCacheResponse as UpdateSchemaCacheResponseOriginal,
  RemoveContentsByFilterRequest as RemoveContentsByFilterRequestOriginal,
  RemoveContentsByFilterResponse as RemoveContentsByFilterResponseOriginal,
  RepublishContentByFilterRequest as RepublishContentByFilterRequestOriginal,
  RepublishContentByFilterResponse as RepublishContentByFilterResponseOriginal,
  ChangeContentLocaleRequest as ChangeContentLocaleRequestOriginal,
  ChangeContentLocaleRequestQueryContextOneOf as ChangeContentLocaleRequestQueryContextOneOfOriginal,
  ChangeContentLocaleResponse as ChangeContentLocaleResponseOriginal,
  RestoreFromTrashBinByQueryRequest as RestoreFromTrashBinByQueryRequestOriginal,
  RestoreFromTrashBinByQueryResponse as RestoreFromTrashBinByQueryResponseOriginal,
  RestoreFromTrashBinByQueryResponseBulkContentResult as RestoreFromTrashBinByQueryResponseBulkContentResultOriginal,
  GetContentWordCountRequest as GetContentWordCountRequestOriginal,
  GetContentWordCountResponse as GetContentWordCountResponseOriginal,
  SchemaWordCount as SchemaWordCountOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
} from './multilingual-translation-v1-content-translation-contents.types.js';
